module.exports = __webpack_public_path__ + "static/media/sq_lalamove.e75c4c73.png";